import { useMemo } from 'react';
import { orderUiLanguagesForCountry, type UiLanguageEntry } from '@/lib/visitor-geo-locale';
import { useLanguageStore } from '@/stores/language.store';
import { usePublicRegionStore } from '@/stores/public-region.store';

/** Langues UI ordonnées selon le pays visiteur (Amazighe en premier au Maroc). */
export function useUiLanguages(): readonly UiLanguageEntry[] {
  const country = useLanguageStore((s) => s.visitorCountryCode);
  const publicRegion = usePublicRegionStore((s) => s.region);
  return useMemo(
    () => orderUiLanguagesForCountry(country, publicRegion),
    [country, publicRegion],
  );
}
